module.exports = __webpack_public_path__ + "img/Alternator.7f226948.jpg";